import React from "react";
import { StyledFooter } from "./FooterVN.styled";

const FooterVN: React.FC = () => {
  return (
    <StyledFooter className="garena-footer">
      <div className="container">
        <div className="bottom">
          <div className="logos" />
          <div className="cnt">
            <div className="copyrights">
              Sản phẩm được hợp tác phát hành bởi Công ty TNHH Liên Minh Huyền
              Thoại & Công ty Cổ phần Giải trí và Thể thao Điện tử Việt Nam.
              <br />
              Văn phòng đại diện: Tầng 29, tòa nhà Trung tâm Lotte Hà Nội, số 54
              đường Liễu Giai, phường Cống Vị, quận Ba Đình, thành phố Hà Nội,
              Việt Nam.
              <br />
              Điện thoại: (04)7305-3939; Fax: (04)3759-2429
            </div>
            <div className="social-links">
              <div className="links">
                <a
                  href="https://www.facebook.com/LienMinhHuyenThoai"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">Facebook</div>
                </a>
                <a
                  href="https://www.youtube.com/user/GarenaVietnam?view_as=subscriber?sub_confirmation=1"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">YouTube</div>
                </a>
                <a
                  href="https://www.garena.vn/terms"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">Điều Khoản Dịch Vụ</div>
                </a>
                <a
                  href="https://hotro.garena.vn/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">Trung Tâm Hỗ Trợ</div>
                </a>
              </div>
            </div>
            <div className="vn-playForFree">
              <a
                href="https://lienminh.garena.vn/download"
                className="playForFree"
              >
                CHƠI MIỄN PHÍ
              </a>
              <span className="age-limit" />
            </div>
          </div>
        </div>
      </div>
    </StyledFooter>
  );
};

export default FooterVN;
